import { CardifAo } from '@/app/cardifao/entities/cardifao'

export interface CardifAoState {
    cardifAos: CardifAo[]
}

export const state: CardifAoState = {
    cardifAos: []
}
